<template>
	<div class="seoTakeDown">
		<div class="top">
			<div class="title">
				<div class="text">
					<div>页面收录情况</div>
					<!-- 网址切换 -->
					<sky-dropdown-select
						class="site-list"
						@change="changeSite"
						v-model="siteId"
						:options="websiteList"
						:props="{ label: 'name', value: 'id' }"
					></sky-dropdown-select>
				</div>
				<el-button type="primary" @click="seoUpset" :disabled="status !== 2 && status !== 3">
					{{ status === 3 ? '开始检测' : '重新检测' }}
				</el-button>
			</div>
			<div class="data">
				<div>
					网站：
					<span class="domain">{{ seoInfo.domain || '--' }}</span>
				</div>
				<div>
					当前网站收录：<span class="count">{{ seoInfo.count || '0' }}</span
					>条
				</div>
				<div>最后查询时间：{{ seoInfo.time || '--' }}</div>
			</div>
		</div>
		<div class="content">
			<div class="iframe_body" v-if="status === 2">
				<iframe
					ref="dialogIframe"
					slot="main"
					:srcdoc="seoInfo.result"
					frameborder="0"
					scrolling="no"
					width="100%"
				></iframe>
				<div ref="modal" class="modal"></div>
			</div>

			<div class="status_body" v-else-if="status === 0">
				<img src="~@/assets/seoTakeDown/loading.png" alt="" />
				<div class="title">数据正在努力生成，请稍后查看</div>
			</div>

			<div class="status_body" v-else-if="status === 1">
				<img src="~@/assets/seoTakeDown/error.png" alt="" />
				<div class="title">查询失败</div>
			</div>

			<div class="status_body" v-else-if="status === 3">
				<img src="~@/assets/seoTakeDown/loading.png" alt="" />
				<div class="title">尚未进行页面收录情况的检测</div>
			</div>
		</div>
	</div>
</template>

<script>
// import mixinsWatch from '@/client/mixinsWatch/mixinsWatch';
import seoTakeDownSer from '@/backend/services/seoTakeDown/seoTakeDownSer.js';

import { getWebsiteByCustomer } from '@/backend/services/account/service';
import { mapGetters } from 'vuex';
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect';

export default {
	name: 'seoTakeDown',
	// mixins: [mixinsWatch],
	components: {
		skyDropdownSelect,
	},
	data() {
		return {
			siteId: '',
			domain: '--',
			websiteList: [],
			seoInfo: {},
			status: 3,
			timer: null,
		};
	},
	computed: {
		...mapGetters(['customerId']),
	},
	watch: {
		customerId: {
			async handler(val) {
				if (val) this.getWebsite();
				else this.$message.warning('您需要先选择一个客户');
			},
			immediate: true,
			deep: true,
		},
	},
	destroyed() {
		if (this.timer) window.clearInterval(this.timer);
	},
	methods: {
		init() {
			this.getSeoInfo();
		},
		// 网站下拉数据
		async getWebsite() {
			try {
				let { customerId } = this;
				let result = await getWebsiteByCustomer({
					customerId,
				});
				this.websiteList = result.data;
				if (result.data.length == 0) return false;
				this.siteId = result.data[0].id;
				this.domain = result.data[0].name;
				this.init();
			} catch (error) {
				console.log(error);
			}
		},
		// 网址选择切换
		changeSite(id) {
			let obj = this.websiteList.find(item => {
				return item.id === id;
			});
			this.domain = obj.name;
			this.init();
		},
		// 获取SEO收录信息
		async getSeoInfo() {
			let { siteId: serviceSiteId } = this;
			let res = await seoTakeDownSer.getSeoInfo({
				serviceSiteId,
			});
			if (res.data) {
				this.seoInfo = res.data;
				if (res.data.status === null) {
					this.judgeState(res.data);
					return;
				}
				if (res.data.status == 'REPORT_COMPLETE' && res.data.result !== null)
					this.judgeState(res.data);
				else this.start();
			}
		},
		// // 开始检测 并轮询检测结果接口
		async start() {
			if (this.timer) window.clearInterval(this.timer);
			this.timer = window.setInterval(() => {
				window.setTimeout(this.getResults, 0);
			}, 3000);
		},
		// 重新检测
		async seoUpset() {
			this.status = 0;
			try {
				let { siteId: serviceSiteId } = this;
				let res = await seoTakeDownSer.seoUpset({
					serviceSiteId,
				});
				if (res.data) this.start();
			} catch (error) {}
		},
		// 获取检测详情
		async getResults() {
			let { siteId: serviceSiteId } = this;
			let res = await seoTakeDownSer.getSeoInfo({
				serviceSiteId,
			});
			if (res) {
				let { data } = res;
				if (data.status == 'REPORT_COMPLETE' && data.result !== null) {
					this.judgeState(data);
					if (this.timer) window.clearInterval(this.timer);
				}
			}
		},
		// 完成的数据处理
		getPictureInfo(data) {
			data.result = `${data.result}`.replace(/"block"/g, '"none"');
			this.seoInfo = data;
			this.status = 2;
			setTimeout(() => {
				var iframe = this.$refs.dialogIframe;
				var modal = this.$refs.modal;
				let height = iframe.contentWindow.document.body.scrollHeight;
				iframe.style.height = height + 'px';
				modal.style.height = height + 'px';
			}, 500);
		},
		// 状态判断
		judgeState(data) {
			let { status } = data;
			// showStatus(0:生成中  1:失败  2:成功  3:未检测)
			switch (status) {
				case 'WAIT':
					this.seoInfo = data;
					this.status = 0;
					break;
				case '':
					this.seoInfo = data;
					this.status = 1;
					break;
				case 'REPORT_COMPLETE':
					this.status = 2;
					this.getPictureInfo(data);
					break;
				case null:
					this.status = 3;
					break;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.seoTakeDown {
	background-color: #fff;
	margin: 0 20px;
	border-radius: 5px;
	padding: 10px 20px;

	.top {
		.title {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 0 25px;

			.text {
				font-size: 24px;
				font-weight: 600;
				color: #333333;

				display: flex;
				align-items: center;

				.site-list {
					margin-left: 10px;
				}
			}
		}

		.data {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 20px;
			font-size: 18px;
			font-weight: 500;
			color: #333333;

			div {
				margin: 0 50px;
			}

			.domain,
			.count {
				color: #3da1ff;
			}
		}
	}

	.content {
		margin-top: 20px;
		border-radius: 5px;
		border: 1px solid #d8d8d8;

		.iframe_body {
			position: relative;
			user-select: none;

			.modal {
				width: 100%;
				top: 0;
				bottom: 0;
				left: 0;
				right: 0;
				position: absolute;
			}
		}

		.status_body {
			height: 600px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.title {
				font-size: 16px;
				font-weight: 550;
				color: #333333;
			}
		}
	}
}
</style>
